import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import SectionHeading from "../SectionHeading";

const FirmDocumentsSection = ({ canAccessPrivateFirmDocs }) => (
	<div>
		<SectionHeading divider>Firm Documents</SectionHeading>
		<div style={{ display: "flex", alignItems: "center", gap: 12 }}>
			<Link to="/firmDocs/public/">Public</Link>
			{canAccessPrivateFirmDocs ? (
				<>
					<span style={{ color: "#ccc" }}>|</span>
					<Link to="/firmDocs/private/">Private</Link>
				</>
			) : null}
		</div>
	</div>
);

const mapStateToProps = (state) => ({
	canAccessPrivateFirmDocs: state.user.canAccessPrivateFirmDocs,
});

export default connect(mapStateToProps)(FirmDocumentsSection);
